var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.8121 0.388184H7.2C2.604 0.388184 0 2.99219 0 7.58818V20.1882C0 24.7842 2.604 27.3882 7.2 27.3882H19.8121C24.408 27.3882 27 24.7842 27 20.1882V7.58818C27 2.99219 24.408 0.388184 19.8121 0.388184Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.531 17.7926C20.531 19.516 19.1035 20.9194 17.3497 20.9195L13.8614 20.9195C12.1112 20.9195 10.6872 19.5203 10.6872 17.7997L10.6872 9.98381C10.6872 8.25975 12.1147 6.857 13.8692 6.85699L17.356 6.85696C19.107 6.85694 20.5309 8.25615 20.5309 9.9767L20.5309 10.6376L20.531 17.7926Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62437 14.2718L8.62533 16.3171C8.83214 16.5281 9.16495 16.5281 9.37106 16.3157C9.5765 16.1034 9.57581 15.7609 9.36969 15.55L8.27334 14.4299L9.32448 14.4299L15.2239 14.4299C15.515 14.4299 15.7512 14.1873 15.7512 13.8885C15.7512 13.5889 15.5149 13.3471 15.2239 13.3471L8.27333 13.3471L9.36966 12.227C9.57578 12.0161 9.57646 11.6737 9.37102 11.4613C9.26762 11.3552 9.13272 11.3017 8.99713 11.3017C8.86291 11.3017 8.72801 11.3552 8.62529 11.4599L6.62436 13.5046C6.52507 13.6066 6.46892 13.7444 6.46892 13.8886C6.46892 14.032 6.52507 14.1698 6.62437 14.2718Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.b8e065775ed52316890d902dc734bdc1.svg";
export { ForwardRef as ReactComponent };